import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Dropdown from 'UIKit/Dropdown'
import Avatar from 'UIKit/Image/Avatar'
import { useUserInfo } from 'state/auth/hooks'
import UserMenuDropdown from './UserMenuDropdown'

const UserMenu: React.FC<BoxProps> = ({ ...props }) => {
  const { hasSession } = useUserInfo()
  const { avatar } = useUserInfo()

  return hasSession ? (
    <Box {...props}>
      <Dropdown dropdownContent={<UserMenuDropdown />} dropdownPosition={'bottom'}>
        <Box width={36} height={36} position="relative">
          <Avatar src={avatar} width={128} height={128} />
        </Box>
      </Dropdown>
    </Box>
  ) : null
}
export default UserMenu
